<template>
  <section>
    <form @submit.prevent="submit">
      <div class="mb-3">
        <label for="username" class="form-label">Username:</label>
        <input type="text" name="username" v-model="form.username" class="form-control" />
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password:</label>
        <input type="password" name="password" v-model="form.password" class="form-control" />
      </div>
      <button type="submit" class="btn btn-primary">Submit</button>
    </form>
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'LoginView',
  data() {
    return {
      form: {
        username: '',
        password: '',
      }
    };
  },
  methods: {
    ...mapActions(['logIn']),
    async submit() {
      const user = new FormData();
      user.append('username', this.form.username);
      user.append('password', this.form.password);
      await this.logIn(user);
      this.$router.push({name: 'home'});
    }
  }
});
</script>
